//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.type.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.AnyAdapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.wintermar.inspection.graphql.type.CompleteInspectionCommandInput
import kotlin.IllegalStateException

public object CompleteInspectionCommandInput_InputAdapter : Adapter<CompleteInspectionCommandInput> {
  override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): CompleteInspectionCommandInput = throw IllegalStateException("Input type used in output position")

  override fun toJson(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    `value`: CompleteInspectionCommandInput,
  ) {
    writer.name("inspectionId")
    AnyAdapter.toJson(writer, customScalarAdapters, value.inspectionId)
  }
}
